import { ulid } from 'ulid'

const state = {
    activeApis: [1],
    activeInsurers: [],
    insuranceApis: {},
    allSubmissions: [],
    currentSubmissions: {},
    currentSubmissionArray: {},
    previousSubmissions: {},
    deferredInsurance: {},
    refreshKey: ulid()
}

const getters = {
    activeApis: state => state.activeApis,
    activeInsurers: state => state.activeInsurers,
    insuranceApis: state => state.insuranceApis,
    allSubmissions: state => state.allSubmissions,
    currentSubmissions: state => state.currentSubmissions,
    currentSubmissionArray: state => state.currentSubmissionArray,
    previousSubmissions: state => state.previousSubmissions,
    deferredInsurance: state => state.deferredInsurance,
    refreshKey: state => state.refreshKey,
}

const mutations = {
    setActiveApis: (state, data) => {
        state.activeApis = data
    },
    setActiveInsurers: (state, data) => {
        state.activeInsurers = data
    },
    setInsuranceApis: (state, data) => {
        state.insuranceApis = data
    },
    setAllSubmissions: (state, data) => {
        state.allSubmissions = data
    },
    setCurrentSubmissions: (state, data) => {
        data.forEach(submission => {
            state.currentSubmissions[submission.insurer_id] = submission
        })
        state.currentSubmissionArray = Object.values(state.currentSubmissions)
    },
    setPreviousSubmissions: (state, data) => {
        state.previousSubmissions = _.groupBy(data, 'insurer_id')
    },
    updateCurrentSubmission: (state, data) => {
        let current = state.currentSubmissions[data.insurer_id]
        if (current) {
            if (current.id !== data.id) {
                if (!_.has(state.previousSubmissions, data.insurer_id, false)) {
                    Vue.set(state.previousSubmissions, data.insurer_id, [])
                }
                state.previousSubmissions[data.insurer_id].push(current)
            }
        }
        state.currentSubmissions[data.insurer_id] = data
        state.currentSubmissionArray = Object.values(state.currentSubmissions)
        state.allSubmissions.push(data)
    },
    updateRefreshKey: (state, data) => {
        state.refreshKey = data ? data : ulid()
    },
    setDeferredInsurance: (state, data) => {
        state.deferredInsurance = data
    }
}

const actions = {
    setActiveApis({ dispatch, commit, state }, data) {
        context.commit("setActiveApis", data)
    },
    setActiveInsurers({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/admin/deferred-insurance/${$store.getters.appId}/get-active-insurers`)
                .then((res) => {
                    commit('setActiveInsurers', res.data)
                    let insuranceApis = {}
                    res.data.forEach((activeApi) => {
                        if (state.activeApis.includes(activeApi.id)) {
                            insuranceApis[activeApi.id] = activeApi.name
                        }
                    })
                    commit('setInsuranceApis', insuranceApis)
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    setSubmissions({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/admin/deferred-insurance/${$store.getters.appId}/get-submissions`, data)
                .then((res) => {
                    commit('setAllSubmissions', res.data.allSubmissions)
                    commit('setCurrentSubmissions', res.data.currentSubmissions)
                    commit('setPreviousSubmissions', res.data.previousSubmissions)
                    commit('setDeferredInsurance', res.data.deferredInsurance)
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    updateCurrentSubmission({ dispatch, commit, state }, data) {
        commit('updateCurrentSubmission', data)
    },
    updateRefreshKey({ dispatch, commit, state }, data) {
        commit('updateRefreshKey', data)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
